import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../../../../commons/services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import moment from 'moment';


@Component({
    selector: 'app-edit-transporteur',
    templateUrl: './edit-transporteur.component.html',
    styleUrls: ['./edit-transporteur.component.css'],
    standalone: false
})
export class EditTransporteurComponent implements OnInit {
  @Input() transporteur;
  @Input() showbtnLog: boolean;
  @Input() depuisEcodechet: boolean;
  @Output() hidefunction = new EventEmitter<any>();
  @ViewChild('msg') msg;
  dataClient: any = [];
  listPays = [];
  dateValidite;

  error = '';
  afficherWinTarifTransporteur: Boolean = false;
  afficherWinTransporteurLogo: Boolean = false;
  isEmpty: Boolean = false;
  isSaved: Boolean = false
  listeSociete = [];


  isClick: Boolean = false

  // paramétrage holding
  public isAppartientHolding: Boolean = false;
  public isParametrageTransporteur: Boolean = false;

  constructor(public common: CommonService, private modalService: BsModalService) {
  }
  listSOcieteHolding = []
  ngOnInit() {
    

    // this.listSOcieteHolding =  this.common.local.getObject('societeHolding')
    this.checkParametrageHolding();
    if (this.depuisEcodechet && this.isAppartientHolding && this.isParametrageTransporteur) {
      this.getSocieteFille();
    }
    this.searchPays();
    if (this.transporteur['id']) {
      this.getDetail(this.transporteur['id']);
    } else {
      this.transporteur['isAucunClient'] = !(this.transporteur['clientFact'] && this.transporteur['clientFact'].id > 0);
    }
  }

  checkParametrageHolding() {
    const societe = this.common.local.getObject('paramSociete') || {};
    this.isAppartientHolding = societe['isAppartientHolding'] ? societe['isAppartientHolding'] : false;
    const paramHolding = this.common.local.getObject('paramHolding') || {};
    this.isParametrageTransporteur = paramHolding['parametrageTransporteur'] ? paramHolding['parametrageTransporteur'] : false;
  }

  modifierTarifTransporteur() {
    this.afficherWinTarifTransporteur = true;
  }

  modifierLogoTransporteur() {
    this.afficherWinTransporteurLogo = true;
  }

  retourWinPrincipale() {
    this.afficherWinTarifTransporteur = false;
    this.afficherWinTransporteurLogo = false;
    // console.log('retourWinPrincipale()');
    // console.log(this.transporteur);
  }

  searchPays() {
    this.listPays = [];
    const list = this.common.getType('typePays') || [];
    list.forEach(elt => {
      elt.libelleObjetEntite = elt.libelle;
      this.listPays.push(elt);
    });
  }

  filterPays(event) {
    this.listPays = [];
    this.common.getType('typePays').forEach(elt => {
      const eventLowerCase = !!event ? event.toLowerCase() : '';
      const libelleToLowerCase = !!elt.libelle ? elt.libelle.toLowerCase() : '';
      if (libelleToLowerCase.startsWith(eventLowerCase) || libelleToLowerCase.toLowerCase().startsWith(eventLowerCase)) {
        elt.libelleObjetEntite = elt.libelle;
        this.listPays.push(elt);
        if (this.transporteur['paysObjet'] && this.transporteur['paysObjet'].id === elt.id) {
          this.transporteur['paysObjet'] = elt;
          this.transporteur['pays'] = elt.libelleObjetEntite;
        }
      }
    });
  }

  returnList() {
    this.hidefunction.emit(this.transporteur);
  }

  save() {
    console.log('save()');
    // console.log('this.transporteur["imageTampon"]=' + this.transporteur['imageTampon']);
    if(this.transporteur['tokenTrackdechet'] && this.transporteur['tokenTrackdechet'].length  != 4) {
      this.error = "Le champ code de sécurité doit contenir 4 chiffres";
      this.common.openModal(this.modalService, this.msg);
       return false;
    }
    if (!this.transporteur['listPrix']) {
      this.transporteur['listPrix'] = [];
    } else {
      this.transporteur['listPrix'].forEach(elt => {
        if (!elt['qualitePrix'] || (elt['qualitePrix'] && !elt['qualitePrix'].id)) {
          elt['qualitePrix'] = { id: 0 };
        }
        if (!elt['article'] || (elt['article'] && !elt['article'].id)) {
          elt['article'] = { id: 0 };
        }
        if (!elt['exutoire'] || (elt['exutoire'] && !elt['exutoire'].id)) {
          elt['exutoire'] = { id: 0 };
        }
        if (!elt['tarif']) {
          elt['tarif'] = 0;
        }
        if (!elt['client'] || (elt['client'] && !elt['client'].id)) {
          elt['client'] = { id: 0 };
        }
        if (!elt['chantier'] || (elt['chantier'] && !elt['chantier'].id)) {
          elt['chantier'] = { id: 0 };
        }
        if (!elt['site'] || (elt['site'] && !elt['site'].id)) {
          elt['site'] = { id: 0 };
        }
      });
    }
    // const isHolding = this.common.local.get('isHolding');
    if (this.isAppartientHolding && this.isParametrageTransporteur  && this.depuisEcodechet && !this.transporteur['id']) {
      this.saveholding();
    } else {
      this.savetransporteur();
    }
  }

  savetransporteur() {
    this.transporteur['nomclass'] = 'Transporteur';
    const param = {
      'servlet': 'DBMAJTransporteur',
      'module': 'Recylog',
      'type': 'objet',
      'compression': 'false',
      'data': this.transporteur
    };


    this.common.post('', { param: param }).then(dt => {
      if (dt.message) {
        this.error = dt.message;
        this.common.openModal(this.modalService, this.msg);
      } else if (dt.data && dt.data === 'ERR_SETTING_TABLE_0') {
        this.error = 'Cette valeur existe déjà';
        this.common.openModal(this.modalService, this.msg);

      } else if (dt.data && dt.data === 'ERR_RAPPORT_1') {
        this.error = 'Une erreur est survenue lors de l\'enregistrement';
        this.common.openModal(this.modalService, this.msg);
      } else if (dt && dt.data && !isNaN(parseInt(dt.data, 10))) {
        this.transporteur['id'] = this.transporteur['id'] || dt.data;
        this.common.createLog('36', dt.data, this.transporteur['id'] ? false : true);
        this.returnList();
      }
    });
  }

  getDetail(id) {
    const param = {
      'servlet': 'DBGetTransporteur',
      'module': 'Recylog',
      'type': 'objet',
      'compression': 'false',
      'data': {
        'typeParam': 'string',
        'valeur': id + ''
      }
    };

    this.common.post('', { param: param }).then(dt => {
      if (dt.message) {
        this.error = dt.message;
        this.common.openModal(this.modalService, this.msg);
      } else {
        this.transporteur = dt.data;
        this.transporteur.isAucunClient = !(this.transporteur.clientFact && this.transporteur.clientFact.id > 0);
        this.dateValidite = this.common.parseDate(moment(this.transporteur.validite, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
        console.log(this.transporteur);
        this.transporteur['listPrix'] = this.transporteur['listPrix'] || [];
        this.transporteur['listPrix'].forEach(elt => {
          if (!elt['qualitePrix'] || (elt['qualitePrix'] && !elt['qualitePrix'].id)) {
            elt['qualitePrix'] = { id: 0 };
          }

          if (!elt['article'] || (elt['article'] && !elt['article'].id)) {
            elt['article'] = { id: 0 };
          }

          if (!elt['exutoire'] || (elt['exutoire'] && !elt['exutoire'].id)) {
            elt['exutoire'] = { id: 0 };
          }

          if (!elt['tarif']) {
            elt['tarif'] = 0;
          }

          if (!elt['client'] || (elt['client'] && !elt['client'].id)) {
            elt['client'] = { id: 0 };
          }

          if (!elt['chantier'] || (elt['chantier'] && !elt['chantier'].id)) {
            elt['chantier'] = { id: 0 };
          }

          if (!elt['site'] || (elt['site'] && !elt['site'].id)) {
            elt['site'] = { id: 0 };
          }
        });
      }
    });
  }

  changeDate(event) {
    if (moment(event).isValid()) {
      this.transporteur.validite = moment(event).format('DD/MM/YYYY');
    } else {
      this.transporteur.validite = moment().format('DD/MM/YYYY');
    }
  }

  selectDate(event, id) {
    this.common.focusElement(id);
  }

  searchClientNew(event) {
    const user = this.common.local.getObject('userDetail') || {};
    this.common.getModule();
    const activedModule = '' + this.common.activedModule;
    const fonctionUser = user.fonctionUser ? (user.fonctionUser.id || 0) : 0;
    const param = {
      'critere': event,
      'type': ['clients'],
      'afficherCodeNomClient': 'true',
      'afficherClientToutProspect': 'false',
      'afficherFactureAvoirNonHistorise': 'false',
      'clefSite': this.common.user[2],
      'clefUser': this.common.user[0],
      'clefFonction': fonctionUser,
      'clefModule': activedModule
    };

    this.common.searchEcoloc({ param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.dataClient = datas.data;
      }
    });
  }

  searchClient(event) {
    this.searchClientNew(event);
  }

  setClient(event) {
    console.log(event);
    switch (event.table) {
      case 'clients':
        this.getClient(event.id);
        break;
      case 'chantiers':
        this.getChantier(event.id);
        break;
    }
  }

  getClient(id) {
    const param = {
      'servlet': 'DBGetClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'true',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': id || 0
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'LOAD_CHANTIER': {
          'typeParam': 'boolean',
          'valeur': false
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        console.log(datas);
        const data = datas.data.length ? datas.data[0] : {};
        this.transporteur['clientFact'] = data || {};
      }
    });
  }

  getChantier(id) {
    const param = {
      'servlet': 'DBGetChantier',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetChantier', id]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        console.log(datas);
        const data = datas.data.length ? datas.data[0] : {};
        this.transporteur['clientFact'] = data['clientFact'] || {};
      }
    });
  }

  changeClient() {
    if (this.transporteur['isAucunClient']) {
      this.transporteur['clientFact'] = {};
    }
  }



  async getSocieteFille() {
    const param = {
      'OPERATION': {
        'typeParam': 'int',
        'valeur': 1
      },
      'SOUS_OPERATION': {
        'typeParam': 'int',
        'valeur': 2
      },
    };

    await this.common.DBGestionParamHoldingAngular(param).then(dt => {
      if (dt.data !== null) {
        this.listeSociete = dt.data || [];
        const tmp = dt.data || [];
        this.listSOcieteHolding = [];
        const societeFille = this.common.local.getObject('societeHolding') || {};
        // this.listSOcieteHolding.forEach(element => {
        //   element.isUserVisible = true
        // });

        this.transporteur['listSociete'] = this.transporteur['listSociete'] || [];
        this.listeSociete.forEach(societe => {
          societe['isUserVisible'] = false;
          if (societe.nom === societeFille.nom) {
            societe['isUserVisible'] = true;
          }
        });

        console.log('this.listeSociete', this.listeSociete)
      }
    });
  }

  saveholding() {
    this.transporteur['nomclass'] = 'Transporteur';
    // this.saveAccesAuxSociete();

    // this.listSOcieteHolding.push(this.common.local.getObject('societeHolding'))
    // this.listSOcieteHolding.forEach(element => {
    //   element.isUserVisible = true
    // });
    console.log(this.listSOcieteHolding)
    this.transporteur['listSociete'] = this.listeSociete;

    const param = {
      'OPERATION': {
        'typeParam': 'int',
        'valeur': 12
      },
      'SOUS_OPERATION': {
        'typeParam': 'int',
        'valeur': 3
      },
      'OBJET': this.transporteur
    };

    console.log('param', param)

    return this.common.DBGestionParamHoldingAngular(param).then(dt => {
      if (dt.message) {
        this.error = dt.message;
        this.common.openModal(this.modalService, this.msg);
      } else if (dt.data && dt.data === 'ERR_SETTING_TABLE_0') {
        this.error = 'Cette valeur existe déjà';
        delete this.transporteur['id'];
        this.common.openModal(this.modalService, this.msg);
      } else if (dt.data && dt.data === 'ERR_RAPPORT_1') {
        this.error = 'Une erreur est survenue lors de l\'enregistrement';
        delete this.transporteur['id'];
        this.common.openModal(this.modalService, this.msg);
      } else {
        // this.common.createLogAutreUrl('36', dt.data, this.transporteur['id'] ? false : true, environment.old_api_url);
        if (!this.transporteur['id']) {
          this.transporteur['id'] = dt.data;
        }
        this.isSaved = true
        this.getdetailbyNom().then(() => {
          this.transporteur['id'] = this.transporteur.id;
          if (this.isSaved) {
            delete this.transporteur['listSociete'];
            this.savetransporteur();
          }
        })
        // this.saveTransporteurInSocieteFille();

      }
    }).catch(err => this.isClick = false);
  }

  getdetailbyNom() {
    // const param = {
    //   'OPERATION': {
    //     'typeParam': 'int',
    //     'valeur': 12
    //   },
    //   'NOM_TRANSPORTEUR': {
    //     'typeParam': 'string',
    //     'valeur': this.transporteur.nom
    //   },
    //   'SOUS_OPERATION': {
    //     'typeParam': 'int',
    //     'valeur': 4
    //   },
    //   'CLEF_OBJET': {
    //     'typeParam': 'int',
    //     'valeur': 0
    //   }
    // };
    const param = {
      'servlet': 'DBGetTransporteurByNom',
      'module': 'Recylog',
      'type': 'string',
      'compression': 'false',
      'data': this.transporteur.nom
    };

    return this.common.post('', { param: param }).then(dt => {
      if (dt.message) {
        this.error = dt.message;
        this.common.openModal(this.modalService, this.msg);
      } else {
        this.transporteur['id'] = dt.data.id;
        console.log(this.transporteur);
        this.isEmpty = false;
      }
    });
  }

  isNumberKey(event: KeyboardEvent): boolean {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    }
    return true;
  }

}
